const BoshLosRedirect = () => null;

export default BoshLosRedirect;
